import React from 'react';
import  GeneralScience2024  from 'views/GeneralScience2024';

const AccountGeneralPage = () => {
  return <GeneralScience2024 />;
};

export default AccountGeneralPage;